import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectAllEntities} from '@ngneat/elf-entities';
import {changeRateStore} from '@store/settings/changeRate/change-rate.store';

export const getChangeRateDataSource = createRequestDataSource({
  store: changeRateStore,
  data$: () => changeRateStore.pipe(selectAllEntities()),
  requestKey: 'getChangeRate',
  dataKey: 'changeRates',
});
